import QRCode from 'qrcode.react';
import React from 'react';

import { Panel } from '../common/panel/Panel.component';
import { Button, Colors } from '../legacy/button/Button.component';
import { Input, InputType } from '../legacy/input/Input.component';
import styles from './RegisterTwoFactorAuth.module.css';

interface Props {
  otpAuthUrl?: string;
  onInit: () => Promise<void>;
  onVerify: (code: string) => Promise<void>;
  onSkip: () => void;
}

export const RegisterTwoFactorAuthComponent: React.FC<Props> = props => {
  const { onInit, onSkip, onVerify, otpAuthUrl } = props;

  const [loading, setLoading] = React.useState(false);

  const [twoFactorCode, setTwoFactorCode] = React.useState<string>('');
  const [show2FADisclaimer, setShow2FADisclaimer] =
    React.useState<boolean>(true);
  const handleTwoFactorCodeChange = React.useCallback((value: string) => {
    setTwoFactorCode(value || '');
  }, []);

  if (otpAuthUrl === undefined || show2FADisclaimer) {
    return (
      <div className={styles.twoFactorAuth}>
        <Panel
          title="TWO FACTOR VERIFICATION"
          className={styles.twoFactorAuthPanel}
        >
          <div className={styles.panelContainer}>
            <p className={styles.twoFactorAuthHeading}>
              We strongly advise that you secure your account with an
              authenticator. To do so please press Secure.
            </p>
            <div className={styles.buttonContainer}>
              <Button color={Colors.COLOR_SCHEME_4} onClick={() => onSkip()}>
                Skip
              </Button>
              <Button
                disabled={loading}
                className={styles.secureAccountButton}
                color={Colors.COLOR_SCHEME_2}
                onClick={async () => {
                  setLoading(true);
                  try {
                    await onInit();
                    setShow2FADisclaimer(false);
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                Secure
              </Button>
            </div>
          </div>
        </Panel>
      </div>
    );
  }

  return (
    <div className={styles.twoFactorAuth}>
      <Panel
        title="CONNECT AUTHENTICATOR"
        className={styles.twoFactorAuthPanel}
      >
        <p className={styles.twoFactorAuthHeading}>
          Scan the QRCode with your authenticator app
        </p>
        <div className={styles.twoFactorQRCode}>
          <QRCode value={otpAuthUrl} />
        </div>
        <Input
          type={InputType.INTEGER}
          label={'Copy the code from your Authenticator App'}
          value={twoFactorCode}
          onChange={handleTwoFactorCodeChange}
        />

        <div className={styles.buttonContainer}>
          <Button color={Colors.COLOR_SCHEME_4} onClick={props.onSkip}>
            Skip
          </Button>
          <Button
            className={styles.secureAccountButton}
            color={Colors.COLOR_SCHEME_2}
            onClick={() => onVerify(twoFactorCode)}
          >
            Verify Code
          </Button>
        </div>
      </Panel>
    </div>
  );
};
